export class FrameBusyLifecycle {
  constructor() {
    this.reset()
  }

  prepare(url, { pager = false } = {}) {
    if (this.pending) return false

    this.pending = true
    this.retryURL = url
    this.pager = pager
    return true
  }

  start(url) {
    // A form/request can supersede an already active navigation without going through
    // `prepare`. Keep pager metadata only for the request prepared by its own click; otherwise
    // retry and focus would incorrectly belong to the previous request.
    const startsPreparedRequest = this.pending && !this.active
    if (!startsPreparedRequest) {
      this.retryURL = url
      this.pager = false
    }

    this.active = true
    this.pending = true
  }

  succeed() {
    // A click-prepared Frame can render before Turbo exposes a request event on the Frame
    // itself. The prepared intent is still sufficient to complete focus and cleanup safely.
    if (!this.pending) return false

    const focus = this.pager
    this.reset()
    return focus
  }

  fail() {
    if (!this.pending) return null

    const retryURL = this.retryURL
    this.active = false
    this.pending = false
    this.pager = false
    return retryURL
  }

  reset() {
    this.active = false
    this.pending = false
    this.pager = false
    this.retryURL = null
  }
}
